import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1rem;
  margin-bottom: 1rem;
`;

export const TruckIcon = styled.img`
  cursor: pointer;
`;

export const TableHeaderContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  padding: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.55rem;
`;

export const SelectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 50%;
  margin-right: 0.5rem;
  margin-bottom: 1rem;
  & > span {
    font-size: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 0;
  }
`;

export const OrdersTableContainer = styled.div`
  display: grid;
  padding: 0 1.5rem 1rem 1.5rem;

  gap: 1rem;
`;

export const TableContainer = styled.div`
  max-width: calc(100vw - 2rem);
  & .truck-btn-cancel-order {
    justify-content: center;
    display: flex;
  }
  & .truck-btn-cancel-order > .hefesto-button {
    padding: 0;
  }
`;

export const TableHeaderColumnContainer = styled.div<{ width?: number }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${({ width }) => width && `min-width: ${width}px`}
`;

export const TableHeaderColumnItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TableHeaderInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TableOrderNumberSelectable = styled.span`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const TableCell = styled.span`
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
`;

export const TableHeaderContainer = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;

  margin-right: 1.5rem;
`;

export const TableHeaderContainerButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const TableHeaderActionButton = styled.div`
  > button {
    padding-inline: 0;
  }

  .hefesto-button__label {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MessageWithoutEmitter = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
